/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { DataProvider } from "./hooks/";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

// 🔴 401 처리는 화면이 아니라 여기 한 곳이다 — 앱이 뜨기 전에 건다.
import installAuthInterceptor from './api/authInterceptor';

installAuthInterceptor();

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <DataProvider>
        <App />
      </DataProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
